import { useTheme } from '@emotion/react';
import Image from '@segment/matcha/components/Image';
import * as views from './ScoreMeter.views';
import scoreMeter0Png2x from './assets/ScoreMeter0@2x.png';
import scoreMeter0Webp from './assets/ScoreMeter0.webp';
import scoreMeter0Webp2x from './assets/ScoreMeter0@2x.webp';
import scoreMeter2Png2x from './assets/ScoreMeter2@2x.png';
import scoreMeter2Webp from './assets/ScoreMeter2.webp';
import scoreMeter2Webp2x from './assets/ScoreMeter2@2x.webp';
import scoreMeter3Png2x from './assets/ScoreMeter3@2x.png';
import scoreMeter3Webp from './assets/ScoreMeter3.webp';
import scoreMeter3Webp2x from './assets/ScoreMeter3@2x.webp';
import scoreMeter4Png2x from './assets/ScoreMeter4@2x.png';
import scoreMeter4Webp from './assets/ScoreMeter4.webp';
import scoreMeter4Webp2x from './assets/ScoreMeter4@2x.webp';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var NUMBER_OF_LEVELS = 4;

var getActiveLevelSrc = function getActiveLevelSrc(activeLevel) {
  var src2 = "";
  var webp = "";
  var webp2 = "";

  switch (activeLevel) {
    case 0:
      src2 = scoreMeter0Png2x;
      webp = scoreMeter0Webp;
      webp2 = scoreMeter0Webp2x;
      break;

    case 2:
      src2 = scoreMeter2Png2x;
      webp = scoreMeter2Webp;
      webp2 = scoreMeter2Webp2x;
      break;

    case 3:
      src2 = scoreMeter3Png2x;
      webp = scoreMeter3Webp;
      webp2 = scoreMeter3Webp2x;
      break;

    case 4:
      src2 = scoreMeter4Png2x;
      webp = scoreMeter4Webp;
      webp2 = scoreMeter4Webp2x;
      break;

    default:
      src2 = scoreMeter0Png2x;
      webp = scoreMeter0Webp;
      webp2 = scoreMeter0Webp2x;
  }

  return {
    src2: src2,
    webp: webp,
    webp2: webp2
  };
};

export var ScoreMeter = function ScoreMeter(_ref) {
  var title = _ref.title,
      rating = _ref.rating,
      score = _ref.score,
      maxScore = _ref.maxScore;
  var scorePercentage = score / maxScore;
  var activeLevel = score === 0 ? 0 : Math.max(Math.ceil(scorePercentage * NUMBER_OF_LEVELS), 1);
  var theme = useTheme();

  var _getActiveLevelSrc = getActiveLevelSrc(activeLevel),
      src2 = _getActiveLevelSrc.src2,
      webp = _getActiveLevelSrc.webp,
      webp2 = _getActiveLevelSrc.webp2;

  return _jsxs(views.Wrapper, {
    children: [_jsxs(views.Container, {
      children: [_jsx(views.Title, {
        variant: "h5",
        tag: "p",
        tokens: {
          color: theme.palette.brand.segmentGreen[500]
        },
        children: title
      }), _jsx(views.Rating, {
        variant: "pLarge",
        tag: "p",
        children: rating
      })]
    }), _jsxs("picture", {
      children: [_jsx("source", {
        type: "image/webp",
        srcSet: "".concat(webp, ", ").concat(webp2, " 2x")
      }), _jsx(Image, {
        width: "641",
        height: "555",
        src: src2,
        alt: "Score meter",
        loading: "lazy"
      })]
    })]
  });
};